import { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { Box } from '@mui/material'
import { Loading } from 'components/ui'
import { getGlobalConsentApi } from 'pages/policies/api'
import { Consent, buildPolicySearch } from 'pages/policies/utils'
import List from 'pages/policies/views/list'

import PrivacyIcon from '../assets/images/privacy_icon.png'

export default function TermsConditionsServiceHistory() {
  const navigate = useNavigate()
  const { appId } = useParams()
  const [searchParams] = useSearchParams()
  const paramCountryCode = searchParams.get('countryCode') || undefined
  const paramLocale = searchParams.get('locale') || undefined
  const policySearch = buildPolicySearch(searchParams)

  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [terms, setTerms] = useState<Consent[]>([])

  const handleListButton = (item) => {
    navigate(`/policies/terms-conditions/services/${item.appKey}/latest${policySearch}`, { state: { consent: item } })
  }

  useEffect(() => {
    getGlobalConsentApi('TC', false, {
      apiURL: '/v1/consent/registered',
      family: true,
      appId,
      overrides: { countryCode: paramCountryCode, locale: paramLocale }
    })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('Failed getConsentApi')
        } else {
          const data = res.data as Consent[]
          setTerms(data)
          return data
        }
      })
      .catch(() => {
        setTerms([])
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [paramCountryCode, paramLocale])

  return (
    <Box sx={{ width: '100%', height: '100%', paddingTop: { xs: '5px', md: '46px' } }}>
      {isLoading ? (
        <Loading fullScreen />
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ width: { xs: '100%', md: '1040px' } }}>
            <List
              handleListButton={handleListButton}
              title={(terms && terms[0]?.title) || ''}
              titleIcon={PrivacyIcon}
              isLoading={isLoading}
              consents={terms}
              isPublishTitle
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}
